<template>
  <div class="col-xs-12 p-0">
    <input
      v-model="searchKeyword"
      autocomplete="search"
      class="search-box search-control font-16"
      :class="{'custom-padding': searchKeyword }"
      type="text"
      :minlength="minLen"
      :maxlength="maxLen"
      :required="required"
      :disabled="disableSearch"
      :placeholder="placeholder"
      @keydown.enter.prevent="emitGetList"
      @keyup="fetchAccountList"
    >
    <div>
      <img
        v-if="searchKeyword && showClearButton"
        src="../../../public/static/images/icons/danger_search_close_icon.svg"
        alt="close-icon"
        class="cursor-pointer search-reset"
        :class="{ 'showSearchIcon': showSearchIcon}"
        @click="resetSearchKeyword"
      >
      <template v-if="showSearchIcon">
        <span class="vertical-line" />
        <span
          class="search-icon cursor-pointer"
          :class="{ 'events-none': disableSearch }"
          @click="emitGetList()"
        >
          <img
            src="../../../public/static/images/icons/new_search.svg"
            alt="search-icon"
          >
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    disableSearch: {
      type: Boolean
    },
    fetchAccountsBasedOnSearch: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minLen: {
      type: String,
      default: ''
    },
    maxLen: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false,
    },
    showSearchIcon: {
      type: Boolean,
      default: true
    },
    showClearButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'fetchAccount', 'getList'],
  data() {
    return {};
  },

  computed: {
    searchKeyword: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },

  methods: {
    resetSearchKeyword() {
      this.searchKeyword = '';
      this.$emit('getList', '');
    },

    fetchAccountList() {
      if (this.fetchAccountsBasedOnSearch) {
        this.$emit('fetchAccount');
      }
    },

    emitGetList() {
      this.$emit('getList', this.searchKeyword);
    }
  }
};
</script>

<style lang="scss" scoped>
.vertical-line {
  top: 5px;
  right: 46px;
  position: absolute;
  border-left: 1px solid $deep-gray;
  height: 75%;
}
.search-reset {
  top: 9px;
  height: 18px;
  width: 18px;
  &.showSearchIcon{
    right: 55px;
  }
}
.search-icon {
  top: 5px;
  position: absolute;
  right: 14px;
  & img {
    width: 24px;
    height: 24px;
  }
}
.search-control {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  border: 0.8px solid #828282;
  border-radius: 20px;
  display: block;
  width: 100%;
  height: 36px;
  padding: 7px 50px 7px 16px;
  &.custom-padding {
    padding-right: 73px;
  }
  &:focus-visible {
    outline: none;
    box-shadow: none;
    padding-left: 15px;
    border: 2px solid #828282;
  }
  &:hover {
    box-shadow: none;
  }
  &:disabled {
    background: #f2f2f2;
    border: 1px solid #828282;
  }
}
.events-none {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
